export const CONSOLIDATED = 'consolidado'

export const ROUTE_RECOVER_PRODUCTS = '/recuperar-margem'